(() => {
  function getState(root) {
    return root._figmaPromo;
  }

  function setState(root, state) {
    root._figmaPromo = state;
  }

  function clearCarouselLayout(track, slides) {
    if (track) {
      track.style.transform = '';
      track.style.transition = '';
    }
    slides.forEach((slide) => {
      slide.style.removeProperty('flex');
      slide.style.removeProperty('flex-basis');
      slide.style.removeProperty('width');
      slide.style.removeProperty('min-width');
      slide.style.removeProperty('max-width');
      slide.style.removeProperty('flex-shrink');
      slide.style.removeProperty('flex-grow');
    });
  }

  function getSlideWidth(root, viewport) {
    const el = viewport || root;
    let w = Math.max(0, Math.round(el.getBoundingClientRect().width));
    if (!w) w = Math.max(0, Math.round(root.getBoundingClientRect().width));
    if (!w) w = Math.max(0, Math.round(window.innerWidth || 0));
    return w;
  }

  function applyCarouselLayout(root, track, slides, viewport) {
    const w = getSlideWidth(root, viewport);
    if (!w) return;

    root.style.setProperty('--figma-slide-px', w + 'px');
    slides.forEach((slide) => {
      slide.style.flex = '0 0 ' + w + 'px';
      slide.style.width = w + 'px';
      slide.style.minWidth = w + 'px';
      slide.style.maxWidth = w + 'px';
    });

    const count = slides.length;
    let idx = parseInt(root.dataset.figmaIndex || '0', 10) || 0;
    if (count > 0) idx = ((idx % count) + count) % count;
    root.dataset.figmaIndex = String(idx);
    track.style.transform = 'translate3d(' + -idx * w + 'px, 0, 0)';
  }

  function destroy(root) {
    const st = getState(root);
    if (!st) return;
    if (st.timer) {
      clearInterval(st.timer);
      st.timer = null;
    }
    st.ro?.disconnect();
    document.removeEventListener('visibilitychange', st.onVis);
    window.removeEventListener('resize', st.onWin);
    st.prevEl?.removeEventListener('click', st.onPrev);
    st.nextEl?.removeEventListener('click', st.onNext);
    if (st.track && st.slides) clearCarouselLayout(st.track, st.slides);
    setState(root, null);
  }

  function build(root) {
    destroy(root);

    const track = root.querySelector('[data-figma-promo-track]');
    const viewport = root.querySelector('[data-figma-promo-viewport]');
    const slideEls = root.querySelectorAll('[data-figma-slide]');
    const prevEl = root.querySelector('[data-figma-promo-prev]');
    const nextEl = root.querySelector('[data-figma-promo-next]');
    if (!track || !viewport || slideEls.length === 0) return;

    const slides = Array.from(slideEls);
    const count = slides.length;
    if (count < 2) {
      clearCarouselLayout(track, slides);
      return;
    }

    const autoAttr = String(root.getAttribute('data-auto-rotate') || '').toLowerCase();
    const autoRotate = autoAttr === 'true' || autoAttr === '1';
    const rotateSpeedSec = Math.max(2, parseInt(root.getAttribute('data-rotate-speed') || '5', 10) || 5);
    const delayMs = rotateSpeedSec * 1000;

    track.style.transition = 'transform 0.4s ease';

    const st = {
      track,
      slides,
      viewport,
      prevEl,
      nextEl,
      ro: null,
      timer: null,
      onWin: null,
      onPrev: null,
      onNext: null,
      onVis: null,
    };
    setState(root, st);

    const go = (delta) => {
      if (count < 2) return;
      let idx = parseInt(root.dataset.figmaIndex || '0', 10) || 0;
      idx = (idx + delta + count) % count;
      root.dataset.figmaIndex = String(idx);
      applyCarouselLayout(root, track, slides, viewport);
    };

    function stopAutoplay() {
      if (st.timer) {
        clearInterval(st.timer);
        st.timer = null;
      }
    }

    function canAutoplay() {
      return autoRotate && count > 1 && document.visibilityState !== 'hidden' && getState(root) === st;
    }

    function startAutoplay() {
      stopAutoplay();
      if (!canAutoplay()) return;
      st.timer = setInterval(() => {
        if (!canAutoplay()) {
          stopAutoplay();
          return;
        }
        go(1);
      }, delayMs);
    }

    function sync() {
      if (!getState(root)) return;
      applyCarouselLayout(root, track, slides, viewport);
      if (!st.ro) {
        st.ro = new ResizeObserver(() => {
          if (getState(root) === st) {
            applyCarouselLayout(root, track, slides, viewport);
          }
        });
        st.ro.observe(viewport);
        st.ro.observe(root);
      }
      startAutoplay();
    }

    st.onPrev = (e) => {
      e?.preventDefault?.();
      go(-1);
      startAutoplay();
    };
    st.onNext = (e) => {
      e?.preventDefault?.();
      go(1);
      startAutoplay();
    };
    st.onWin = () => {
      if (getState(root) === st) {
        applyCarouselLayout(root, track, slides, viewport);
      }
    };
    st.onVis = () => {
      if (document.visibilityState === 'hidden') stopAutoplay();
      else startAutoplay();
    };

    prevEl?.addEventListener('click', st.onPrev);
    nextEl?.addEventListener('click', st.onNext);
    document.addEventListener('visibilitychange', st.onVis);
    window.addEventListener('resize', st.onWin);

    sync();
    setTimeout(() => {
      if (getState(root) !== st) return;
      applyCarouselLayout(root, track, slides, viewport);
      startAutoplay();
    }, 150);
  }

  function initAll() {
    document.querySelectorAll('[data-figma-promo-root]').forEach((root) => build(root));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', (event) => {
    event.target?.querySelectorAll?.('[data-figma-promo-root]')?.forEach((root) => destroy(root));
  });
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target?.closest?.('[data-figma-promo-root]');
    if (!root) return;
    const slides = root.querySelectorAll('[data-figma-slide]');
    const idx = Array.from(slides).findIndex((el) => el.contains(event.target) || el === event.target);
    if (idx >= 0) {
      root.dataset.figmaIndex = String(idx);
      destroy(root);
      build(root);
      root.dataset.figmaIndex = String(idx);
      const st = getState(root);
      if (st) applyCarouselLayout(root, st.track, st.slides, st.viewport);
    }
  });
  document.addEventListener('shopify:block:deselect', () => {
    const root = document.querySelector('[data-figma-promo-root]');
    if (root) build(root);
  });
})();
